import Box from 'components/shared/Box'
import RouteTitle from 'components/shared/RouteTitle'
import { getDayNameAndDate, getDayNameAndDateWithTime } from 'helpers/dates'
import { directionNames } from 'routes/Upsell/Bus/data'
import { useIntl } from 'react-intl'
import { useApp } from 'store/steps'
import { Color } from 'styles/types'
import TicketItem from './TicketItem'
import { TransportReservation } from 'store/selfcare-slice/types'

interface TransportItemProps {
    transportTicket: TransportReservation
    isDisabled?: boolean
    hasCounter?: boolean
}

const TransportItem = ({
    transportTicket,
    isDisabled,
    hasCounter,
}: TransportItemProps) => {
    const { formatMessage } = useIntl()
    const { stepId } = useApp()

    const { changes, original } = transportTicket
    const isSummary = stepId === 'summary'
    const dataToDisplay = isSummary && changes ? changes : original
    const { detail, quantity } = dataToDisplay || {}
    const { date, departurePlace, routeType, time, returnDate, returnTime } =
        detail || {}
    const from =
        routeType === 'from_park'
            ? directionNames.suntago
            : directionNames[departurePlace]
    const to =
        routeType === 'from_park'
            ? directionNames[departurePlace]
            : directionNames.suntago

    const isRouteChanged =
        changes &&
        (changes.detail.routeType !== original.detail.routeType ||
            changes.detail.departurePlace !== original.detail.departurePlace)
    const isDateChanged =
        changes && changes.detail.date !== original.detail.date
    const isReturnDateChanged =
        changes && changes.detail.returnDate !== original.detail.returnDate
    const isTimeChanged =
        changes && changes.detail.time !== original.detail.time
    const isReturnTimeChanged =
        changes && changes.detail.returnTime !== original.detail.returnTime
    let routeColor: Color =
        isSummary && isRouteChanged ? 'primary_500' : 'grayscale_900'

    if (isDisabled) routeColor = 'grayscale_700'

    const consideredQuantity = hasCounter ? quantity : undefined

    return (
        <Box gap={[16, 24]} isFullWidth>
            <TicketItem
                date={
                    time
                        ? getDayNameAndDateWithTime({ date, time })
                        : getDayNameAndDate({ date })
                }
                editedItem={isDateChanged || isTimeChanged ? 'date' : undefined}
                isDisabled={isDisabled}
                quantity={consideredQuantity}
            >
                <RouteTitle
                    from={formatMessage(from)}
                    to={formatMessage(to)}
                    variant="bodySmall"
                    hasSmallDots
                    color={routeColor}
                />
            </TicketItem>
            {routeType === 'to_from_park' && (
                <TicketItem
                    date={
                        returnTime
                            ? getDayNameAndDateWithTime({
                                  date: returnDate,
                                  time: returnTime,
                              })
                            : getDayNameAndDate({ date: returnDate })
                    }
                    editedItem={
                        isReturnDateChanged || isReturnTimeChanged
                            ? 'date'
                            : undefined
                    }
                    isDisabled={isDisabled}
                    quantity={consideredQuantity}
                >
                    <RouteTitle
                        from={formatMessage(to)}
                        to={formatMessage(from)}
                        variant="bodySmall"
                        hasSmallDots
                        color={routeColor}
                    />
                </TicketItem>
            )}
        </Box>
    )
}

export default TransportItem
